module.exports = __webpack_public_path__ + "assets/img/Motocycle_1.661a6d06.png";